import { Box, Grid, Typography, TextField } from '@mui/material';

export default function StepBce({ t, inputValue, handleChange, handlePaste, inputRef }) {
  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={2} alignItems="start">
        <Grid item xs={12} md={5}>
          <Typography component="h3" variant="h4" sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '42px' } }}>
            {t('survey.create.stepper.whichCompany')}
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography sx={{ display: 'block', mb: 1, fontSize: '25px', color: '#0d93d2', fontWeight: 700 }}>
            {t('survey.create.stepper.whichCompany')}
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            inputMode="numeric"
            value={inputValue}
            onChange={handleChange}
            onPaste={handlePaste}
            inputRef={inputRef}
            inputProps={{ pattern: '[0-9]*', maxLength: 10 }}
            placeholder={t('survey.create.stepper.numberBce')}
            helperText={t('survey.create.stepper.helper')}
            sx={{
              mt: 0.8,
              '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
                '& fieldset': { borderColor: '#58d7ff' },
                '&:hover fieldset': { borderColor: '#58d7ff' },
                '&.Mui-focused fieldset': { borderColor: '#58d7ff' }
              },
              '& .MuiInputBase-input': { padding: '12px 14px' },
              '& .MuiFormHelperText-root': { ml: 0, mt: 2 }
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}